import { ref } from "vue";
const preferences = ref({});
export const usePreferences = () => {
    const persist = () => {
        // for now we will just use local storage
        if (!localStorage) return;
        localStorage.setItem("preferences", JSON.stringify(preferences.value));
    };

    const load = () => {
        if (!localStorage) return;
        const data = localStorage.getItem("preferences");
        if (data) {
            preferences.value = JSON.parse(data);
        }
    };
    load();

    const setPreference = (key, value) => {
        preferences.value[key] = value;
        persist();
    };

    const getPreference = (key) => {
        return preferences.value[key];
    };

    return {
        setPreference,
        getPreference,
        preferences,
    };
};
